import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { Customer } from '@fc-core/models';
import { NotificationComponent } from '@fc-core/services/notification.component';

@Component({
  selector: 'fc-payment-notification',
  template: `
    @if (!isDismissed()) {
      <div
        class="flex flex-row fixed bottom-0 left-0 right-0 z-9999! justify-center pointer-events-none"
      >
        <fc-notification
          type="error"
          [closeable]="true"
          class="pointer-events-auto"
          (ondestroy)="isDismissed.set(true)"
        >
          <div class="flex text-error-600 flex-wrap">
            ⚠️ Your account is past due.
            <a
              target="_blank"
              [href]="customer()?.paymentMethodUrl"
              class="text-primary-600"
            >
              &nbsp;Update your payment&nbsp;</a
            >
            within 30 days of a failed payment or your service will be
            suspended. If you have any questions
            <a href="mailto:support@fleetchaser.com" class="text-primary-600"
              >&nbsp;contact us</a
            >.
          </div>
        </fc-notification>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationComponent],
})
export class PaymentNotificationComponent {
  readonly customer = input.required<Customer>();
  readonly isDismissed = signal(false);
}
